<header>
    <nav class="navbar">
        <div class="navbar-section">
          <button class="btn-back black" (click)="back()">
            <mat-icon class="icon-arrow">arrow_back_ios</mat-icon>
            Regresar
          </button>

            <h1 class="navbar-title">{{title}}</h1>

            <button class="btn-back yellow" (click)="volverInicio()">
              <mat-icon>home</mat-icon>
              Regresar al inicio
            </button>

        </div>
     <!-- <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon class="icon-info" aria-hidden="false" aria-label="info">info</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="bg-919191">
        <div class="panel-info">
          <p>{{info}}</p>
        </div>
      </mat-menu> -->

    </nav>
</header>
